export default __webpack_public_path__ + "static/media/icon-prototype-evaluation.e8ab3280.svg";